import React from "react";
import CopyImg from "assets/Images/copy-icon.svg";
import { Button, Col, Input, Row, message } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import SkeletonBlock from "commons/SkeletonBlock";
import { useActiveCompanyData } from "hooks/CompanyHooks";

export default function WebchatPreviewButtonPopover({ url, loading, hide }) {

  const copyText = (name) => {
    if (name === "link") {
      navigator.clipboard.writeText(url);
      message.success("Link copied!");
    }
  };

    const activeCompanyData = useActiveCompanyData();
  
  return (
    <div style={{ width: 500, height:"auto" , position: "relative" }} className="publish">
      <Button
        style={{
          color: "#ffff",
          position: "absolute",
          right: 0,
          top: 0,
          zIndex: 99,
        }}
        type="text"
        onClick={hide}
      >
        <CloseOutlined />
      </Button>
      <Row
        style={{
          background: "#124173",
          padding: "26px 0px",
          display: "flex",
          justifyContent: "center",
          fontSize: "24px",
          fontWeight: "600",
          lineHeight: "29px",
          color: "white",
        }}
      >
        Preview ChatStream
      </Row>

      <Row className="wrapper-box" gutter={10}>
        <Col span={18} xs={24} sm={18}>
          <div>
            <h3>Share your link</h3>
            {loading ? (
              <SkeletonBlock style={{ height: 30, width: 250 }} />
            ) : (
              <Input.Group compact className="input-group">
                <Input style={{ width: "60%" }} value={url} disabled />
                <Input
                  style={{ width: "40%" }}
                  value={activeCompanyData.name}
                  disabled
                />
              </Input.Group>
            )}
          </div>
        </Col>
        <Col
          span={6}
          xs={24}
          sm={6}
          style={{ display: "flex", alignItems: "flex-end" }}
          className="mt-3"
        >
          {loading ? (
            <SkeletonBlock style={{ height: 30, width: 70 }} />
          ) : (
            <Button
              className="standard-button primary-dark-blue-button"
              onClick={() => copyText("link")}
              icon={
                <img
                  src={CopyImg}
                  style={{ height: 15, paddingRight: 10 }}
                  alt=""
                />
              }
            >
              Copy
            </Button>
          )}
        </Col>
      </Row>

    </div>
  );
}
